import React from 'react';

import { CollapsiblePanelSettings } from '@white-nl/instantsearch-components/dist/types/components';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDown } from '../../ui/icons/sharp/regular';

export default function CollapsiblePanel({
  children,
  header = null,
  footer = null,
  collapsiblePanelSettings = {
    classNames: {},
    defaultExpanded: true,
    canCollapse: true,
  },
}: {
  children: React.ReactNode;
  header?: React.ReactNode | null;
  footer?: React.ReactNode | null;
  collapsiblePanelSettings?: CollapsiblePanelSettings;
}) {
  const {
    classNames,
    defaultExpanded,
    canCollapse,
  } = collapsiblePanelSettings;

  const buttonClass = [
    'opener w-full flex justify-between text-left items-center gap-x-2.5 py-3 border-t border-dark/10 font-medium leading-tight text-md md:text-xl text-dark',
    canCollapse ? 'cursor-pointer transition-colors hover:text-orange' : '',
  ].filter(Boolean).join(' ');

  return (
    <Disclosure as="div" className="open-close group/open-close" defaultOpen={defaultExpanded}>
      {header && (
        <DisclosureButton
          as={canCollapse ? 'button' : 'div'}
          className={buttonClass}
        >
          {header}
          {canCollapse && (<ChevronDown iconClass="w-3.5 transition-all text-dark group-data-[open]/open-close:rotate-180 group-data-[open]/open-close:text-accent" />)}
        </DisclosureButton>
      )}
      <DisclosurePanel
        static={!canCollapse}
        transition={canCollapse}
        className={canCollapse ? 'origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0' : ''}
      >
        {children}
      </DisclosurePanel>
      {footer && (
        <div className={`collapsible-panel__footer ${classNames?.footer || ''}`}>
          {footer}
        </div>
      )}
    </Disclosure>
  );
}
